import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { WorkOrderState } from 'app/_models/work-order-state';

@Component({
  selector: 'checkout-modal',
  templateUrl: './checkout-modal.component.html',
})
export class CheckoutModalComponent implements OnInit {

  @Output() checkOutTypeSelected = new EventEmitter<{ type: any, checkWorker: any, workerSession: Checkout; }>();
  @Input() workOrderState: WorkOrderState;
  @Input() leadWorkerSession: any;
  @Input() addSessionWorkers: any;

  public additionalWorkers: any = [];
  public leadWorker: any;

  constructor(
    private activeModal: NgbActiveModal,
  ) { }

  ngOnInit() {
    this.filterAdditionalWorker();
  }

  public closeModal() {
    this.activeModal.dismiss();
  }

  public checkOut(checkOutType, isAddWorker, siteSessionId?, workerUserId?) {
    const type = checkOutType;
    const checkWorker = isAddWorker;

    let workerSession: Checkout = {
      siteSessionId: siteSessionId,
      workerUserId: workerUserId,
    }

    this.checkOutTypeSelected.emit({ type, checkWorker, workerSession } as { type, checkWorker, workerSession: Checkout });
    this.closeModal();
  }

  public filterAdditionalWorker() {
    this.additionalWorkers = this.addSessionWorkers.map(worker => this.mapSessionWorker(worker));
    this.leadWorker = this.mapSessionWorker(this.leadWorkerSession);
  }

  private mapSessionWorker(worker: any) {
    return {
      name: `${worker.user.firstName} ${worker.user.lastName} (${worker.user.login})`,
      siteSessionId: worker.siteSession.id,
      workerUserId: worker.user.id,
    };
  }
}

interface Checkout {
  siteSessionId: number,
  workerUserId: number,
}
